import React from "react";


const CTASection = () => {
 

  
  const handleGetInTouch = () => {
    window.location.href = "/contact";
  };
  return (
    <div className="relative py-12 px-6 overflow-hidden">
      {/* Gradient Background */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(to bottom, #c99c48 0%, #8b7035 50%, #4a4a4a 100%)",
        }}
      ></div>

      {/* Content */}
      <div
        className="relative z-10 max-w-4xl mx-auto text-center"
        data-aos="fade-up"
      >
        <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-6 leading-tight">
          Let's start planning your next high-end corporate event
        </h2>

        <p className="text-white text-lg md:text-xl mb-8 opacity-90 max-w-2xl mx-auto leading-relaxed">
           From intimate executive gatherings to large-scale conferences, we create unforgettable experiences that elevate your brand and exceed expectations.
        </p>

        <button
          onClick={handleGetInTouch}
          className="bg-[#c99c48] text-white px-8 py-4 rounded-2xl text-lg font-semibold hover:bg-[#b88b3f] transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
        >
          Explore Now
        </button>
      </div>

      {/* Optional decorative elements */}
      {/* <div className="absolute top-10 left-10 w-2 h-2 bg-white bg-opacity-30 rounded-full"></div>
      <div className="absolute top-32 right-16 w-3 h-3 bg-white bg-opacity-20 rounded-full"></div>
      <div className="absolute bottom-16 left-20 w-4 h-4 bg-white bg-opacity-25 rounded-full"></div>
      <div className="absolute bottom-10 right-10 w-2 h-2 bg-white bg-opacity-30 rounded-full"></div> */}
    </div>
  );
};

export default CTASection;
